@if (activeLegends && activeLegends.length > 0) {
  <div class="legendWrapper" 
       [class.horizontal]="applicationSettings?.option?.legendBar?.horizontal"
       [class.centered]="applicationSettings?.option?.legendBar?.center">
    <div class="legend-bar" 
         [class.horizontal]="applicationSettings?.option?.legendBar?.horizontal">
      @for (legend of activeLegends; track legend.legendURL) {
      <div class="legend-item">
        @if (legend.title) {
        <span class="legend-title" [innerHTML]="legend.title"></span>
        }
        <img [src]="legend.legendURL" alt="Legend" />
      </div>
      }
    </div>
  </div>
}